import React from "react";
import { DownloadOutlined } from '@ant-design/icons';
import { Button } from "antd";

function Download() {
  return (
    <Button type="primary" color="white" shape="round" icon={<DownloadOutlined />}>
      <a
        href="http://160.251.120.163:5000/files/download"
        download
        style={{color:'white'}}
      >
        Download
      </a>
    </Button>



  );
}

export default Download;